import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M17 15a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H17Zm0 8a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H17Zm-1 9a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H17a1 1 0 0 1-1-1Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M39.332 13.12C39.74 15.102 40 19.422 40 24c0 4.578-.26 8.898-.664 10.861-.783 4.19-3.733 7.501-7.48 8.384-1.83.474-4.72.755-7.856.755-3.137 0-6.026-.28-7.835-.75-3.768-.888-6.718-4.2-7.497-8.37C8.26 32.898 8 28.578 8 24c0-4.578.26-8.898.664-10.861.783-4.19 3.733-7.501 7.48-8.384C17.974 4.281 20.864 4 24 4c3.131 0 6.015.28 7.846.752 3.763.892 6.708 4.201 7.486 8.368ZM31.4 6.804l-.021-.005c-1.651-.428-4.389-.694-7.378-.694s-5.727.266-7.399.7c-2.978.701-5.342 3.355-5.978 6.76C10.253 15.363 10 19.562 10 24c0 4.438.253 8.638.626 10.455.633 3.385 2.997 6.039 5.996 6.746 1.651.428 4.389.694 7.378.694s5.727-.266 7.399-.7c2.978-.701 5.342-3.355 5.978-6.76.37-1.797.623-5.997.623-10.435 0-4.438-.253-8.637-.626-10.455-.633-3.385-2.997-6.039-5.975-6.74Z",
      clipRule: "evenodd"
    }
  )
);
var SvgToDoOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ToDoOutlined_default = SvgToDoOutlined;

export { ToDoOutlined_default as default };
